import styled from 'styled-components';

export const ManageBankDrawerStyles = styled.div`
	height: 100%;

	.current-pill {
		white-space: nowrap;
		border: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
		border-radius: 1rem;
		padding: 0.25rem 0.5rem;
	}

	.options-warning {
		margin-bottom: 1rem;
	}
`;
